<template>
    <div class="container" style="max-width: 1200px;">
        <div class="page-subtitle">Hi {{ user.name }}</div>
        <p class="page-description">Submit Meter Reads</p>

        <property-details class="mb-3"/>

        <div class="box mb-3">
            <div class="box__body reading-info">
                <h3>What to do</h3>
                <br>
                <ol>
                    <li>Please enter your read and the date it was taken in the boxes below and then submit</li>
                    <li>If the previous read shown is actual (A) or manual (M) or customer (C) then your read will normally be higher</li>
                    <li>If the previous read is estimated (E) then your read maybe above or below</li>
                    <li>It is a good idea to take a picture of the meter / read in case of any query</li>
                    <li>Thank you!</li>
                </ol>
            </div>
        </div>
        <tabs class="reading-tabs">
            <tab v-for="supplyItem in selected_property.supplyTypeList" :key="supplyItem.supplyType" :color="supplyItem.supplyTypeColourRGB" :icon="supplyItem.supplyTypeImage ? supplyItem.supplyTypeImage : null" :name="supplyItem.supplyType">
                <div class="table-responsive">
                    <table class="table mb-4 --row-readings">
                        <thead :style="{ background: supplyItem.supplyTypeColourRGB }">
                        <tr class="tab-title-mobile">
                            <th colspan="2">{{ supplyItem.supplyType }}</th>
                        </tr>
                        <tr>
                            <th class="d-none d-md-table-cell">Date</th>
                            <th class="d-none d-md-table-cell" v-for="reg in getRegisters(supplyItem.supplyType)" :key="reg.padded">{{ reg.type }}</th>
                            <th class="d-md-none">Date / Readings</th>
                            <th>Meter</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="read in reads[supplyItem.supplyType].readList" :key="read.readID">
                            <td class="d-none d-md-table-cell">{{ read.readDate | moment('DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss') }}</td>
                            <td class="d-none d-md-table-cell" v-for="reg in getRegisters(supplyItem.supplyType)" :key="reg.padded">
                                <span v-tooltip="read.readType">{{ read[reg.valueKey] }} ({{ read.readTypeAbbreviation }})</span>
                            </td>
                            <td class="reading-table-wrapper d-md-none">
                                <table class="reading-table">
                                    <tr>
                                        <td>Date:</td>
                                        <td>{{ read.readDate | moment('DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss') }}</td>
                                    </tr>
                                    <tr v-for="reg in getRegisters(supplyItem.supplyType)" :key="reg.padded">
                                        <td>{{ reg.type }}:</td>
                                        <td>{{ read[reg.valueKey] }} ({{ read.readTypeAbbreviation }})</td>
                                    </tr>
                                </table>
                            </td>
                            <td>{{ read.meterNumber }}</td>
                        </tr>
                        <tr>
                            <td class="d-none d-md-table-cell">
                                <form-input type="date" size="sm" v-model="reads[supplyItem.supplyType].date" :v="$v.reads[supplyItem.supplyType].date"/>
                            </td>
                            <td class="d-none d-md-table-cell" v-for="reg in getRegisters(supplyItem.supplyType)" :key="reg.padded">
                                <form-input type="number" size="sm" :placeholder="reg.type"  :v="$v.reads[supplyItem.supplyType].registerValues[reg.padded]" v-model="reads[supplyItem.supplyType].registerValues[reg.padded]" decimals="0"/>
                            </td>
                            <td class="reading-table-wrapper d-md-none">
                                <table class="reading-table">
                                    <tr>
<!--                                        <td>Date:</td>-->
                                        <td>
                                            <form-input type="date" size="sm" v-model="reads[supplyItem.supplyType].date" :v="$v.reads[supplyItem.supplyType].date"/>
                                        </td>
                                    </tr>
                                    <tr v-for="reg in getRegisters(supplyItem.supplyType)" :key="reg.padded">
<!--                                        <td>{{ reg.type }}:</td>-->
                                        <td>
                                            <form-input type="number" size="sm" :placeholder="reg.type" :v="$v.reads[supplyItem.supplyType].registerValues[reg.padded]" v-model="reads[supplyItem.supplyType].registerValues[reg.padded]" decimals="0"/>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td>
                                <form-btn size="sm" class="btn-outline-secondary btn-block" :loading="loading[supplyItem.supplyType]" @click="submitReading(supplyItem.supplyType)">Submit</form-btn>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </tab>
        </tabs>

    </div>
</template>

<script>

import PropertySelect from '../components/PropertySelect'
import PropertyDetails from '../components/PropertyDetails'
import moment from 'moment'
import { mapState } from 'vuex'
import Tabs from '../components/Tabs'
import Tab from '../components/Tab'
import {requiredIf} from "vuelidate/lib/validators";
const { required } = require('vuelidate/lib/validators')

export default {
    name: 'SubmitReadings',
    components: { Tab, Tabs, PropertyDetails, PropertySelect },
    data () {
        return {
            loading: { data: false },
            reads: {}
        }
    },
    validations () {
        const reads = {}
        if (this.selected_property && this.selected_property.supplyTypeList) {
            this.selected_property.supplyTypeList.forEach(({ supplyType }) => {
                const registerValidations = {}
                const registerValues = this.reads[supplyType] && this.reads[supplyType].registerValues
                if (registerValues) {
                    Object.keys(registerValues).forEach(key => {
                        registerValidations[key] = { required }
                    })
                }
                reads[supplyType] = {
                    date: { required },
                    registerValues: registerValidations,
                }
            })
        }
        return { reads }
    },
    created () {
        this.initReads()
    },
    mounted () {
        this.getAllReads()
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
            selected_property: (state) => state.selected_property,
        }),
    },
    watch: {
        selected_property () {
            this.initReads()
            this.getAllReads()
        }
    },
    methods: {
        initReads () {
            const reads = {}
            const loading = { data: false }
            if (this.selected_property && this.selected_property.supplyTypeList) {
                this.selected_property.supplyTypeList.forEach(({ supplyType }) => {
                    reads[supplyType] = {
                        date: moment().format('YYYY-MM-DD'),
                        readList: [],
                        registerValues: {},
                    }
                    loading[supplyType] = false
                })
            }
            this.reads = reads
            this.loading = loading
        },
        getAllReads () {
            this.selected_property.supplyTypeList.forEach((supplyType) => {
                this.getReads(supplyType.supplyType)
            })
        },
        getReads (supplyType) {
            if (!this.selected_property) {
                return
            }
            let filters = {
                pagenumber: 0,
                rowsperpage: 2,
                propertyid: this.selected_property.billingPropertyID,
                supplytype: supplyType,
            }

            this.$http.get('/userreads', { params: filters })
                .then((res) => {
                    const registerValues = {}
                    for (let i = 1; i <= 6; i++) {
                        const padded = String(i).padStart(2, '0')
                        if (res.body[`register${padded}Type`]) {
                            registerValues[padded] = ''
                        }
                    }
                    this.reads[supplyType] = {
                        ...res.body,
                        date: this.reads[supplyType] ? this.reads[supplyType].date : moment().format('YYYY-MM-DD'),
                        registerValues,
                    }
                    this.loading.data = false
                })
                .catch(() => {
                    this.loading.data = false
                })
        },
        getRegisters (supplyType) {
            const data = this.reads[supplyType]
            if (!data) return []
            const registers = []
            for (let i = 1; i <= 6; i++) {
                const padded = String(i).padStart(2, '0')
                if (data[`register${padded}Type`]) {
                    registers.push({
                        padded,
                        type: data[`register${padded}Type`],
                        valueKey: `register${padded}Value`,
                    })
                }
            }
            return registers
        },
        submitReading(type) {
            this.$v.reads[type].$touch()
            if (this.$v.reads[type].$invalid === true) {
                alert('Please provide values for all registers. If you don\'t have a read for a specific register, please insert the value "0".')
                return false
            }
            this.loading[type] = true
            const registerParams = {}
            this.getRegisters(type).forEach(reg => {
                registerParams[`readValue${reg.padded}`] = this.reads[type].registerValues[reg.padded]
            })
            this.$http.get('/userpostdata', {params: {
                postType: 'Read',
                propertyid: this.selected_property.billingPropertyID,
                supplytype: type,
                postdate: this.reads[type].date,
                ...registerParams,
            }})
                .then(() => {
                    this.getReads(type)
                    this.reads[type].date = moment().format('YYYY-MM-DD')
                    this.$v.reads[type].$reset()
                    this.loading[type] = false;
                    window.scrollTo({top: 0, behavior: 'smooth'});
                })
                .catch(() => {
                    this.loading[type] = false
                })
        }
    }
}
</script>
